<template>
  <div class="page_injuryTables">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <!-- <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="险种名称" size="small">
              <el-input v-model="listQuery.InsuranceName" size="small" clearable></el-input>
            </el-form-item>
          </el-form> -->
        </div>
      </div>
      <div class="top-right">
        <!-- <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button> -->
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>工伤一览表</el-breadcrumb-item>
          <el-breadcrumb-item>赔付明细2-商保1</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addNew">&nbsp;新增+</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="Sort" label="序号" width="60" align="center" fixed="left">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="r.Idcard" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="r.TimeInjury" label="发生工伤日期" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.InjuredEmployeeName" label="工伤员工姓名" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="rw.BranchOffice" label="分公司" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.SecondReportingParty" label="第二申报方（商保1）" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.WorkInjuryMedicalExpense" label="工伤医疗费" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InsuranceCompReimbursesTime" label="保司告知杰博时间" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.FullNameReceivingAccount" label="到账单位全称（保司-杰博）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingDate" label="到账时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.OneTimeDisabilityBenefit" label="一次性伤残补助金" width="125" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InsuranceCompReimbursesTime1" label="保司告知杰博时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.FullNameReceivingAccount1" label="到账单位全称（保司-杰博）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingDate1" label="到账时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Other" label="其他" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InsuranceCompReimbursesTime2" label="保司告知杰博时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.FullNameReceivingAccount2" label="到账单位全称（保司-杰博）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingDate2" label="到账时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InjuryPay" label="工伤工资" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InsuranceCompReimbursesTime3" label="保司告知杰博时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.FullNameReceivingAccount3" label="到账单位全称（保司-杰博）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingDate3" label="到账时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.OneTimeWorkInjuryBenefit3" label="一次性工伤医疗补助金" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InsuranceCompReimbursesTime4" label="保司告知杰博时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.FullNameReceivingAccount4" label="到账单位全称（保司-杰博）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingDate4" label="到账时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.DepartureTime" label="离职时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.OneTimeWorkInjuryBenefit4" label="一次性伤残就业补助金" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InsuranceCompReimbursesTime5" label="保司告知杰博时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.FullNameReceivingAccount5" label="到账单位全称（保司-杰博）" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingDate5" label="到账时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.ThreeTimePackages" label="三个一次性打包价" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.InsuranceCompReimbursesTime6" label="保司告知杰博时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.FullNameReceivingAccount6" label="到账单位全称（保司-杰博）" width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.AccountingDate6" label="到账时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Total" label="合计" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark1" label="商保1赔付备注1" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="r.Remark2" label="商保1赔付备注2" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right" width="90px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="edit(row)">编辑</el-button>
                <el-popconfirm title="请确定是否作废？" @confirm="del(row)" style="margin-left: 10px;">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增" :visible.sync="showAdd" width="1050px">
      <div class="formData">
        <el-form :model="formData" :inline="true" ref="formData" :rules="rules" label-width="170px">
          <el-form-item label="身份证号码" prop="Idcard">
            <el-input v-model.trim="formData.Idcard" style="width:300px" size="small" @blur="getIdcardInfo"></el-input>
          </el-form-item>
          <el-form-item label="发生工伤日期" prop="TimeInjury">
            <!-- <el-date-picker type="date" placeholder="" v-model="formData.TimeInjury" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker> -->
            <el-select v-model="formData.TimeInjury" placeholder="" clearable size="small" style="width:300px" value-key="Id" @change="changeTimeInjury">
              <el-option v-for="(item,index) in injuryDateList" :key="index" :label="item.TimeInjury" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤员工姓名">
            <el-input v-model="name" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input v-model="proName" disabled readonly style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="第二申报方（商保1）" prop="SecondReportingParty">
            <el-input v-model="formData.SecondReportingParty" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤医疗费" prop="WorkInjuryMedicalExpense">
            <el-input v-model="formData.WorkInjuryMedicalExpense" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="保司告知杰博时间" prop="InsuranceCompReimbursesTime">
            <el-date-picker type="date" placeholder="" v-model="formData.InsuranceCompReimbursesTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账单位全称（保司-杰博）" prop="FullNameReceivingAccount">
            <el-input v-model="formData.FullNameReceivingAccount" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="到账时间" prop="AccountingDate">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingDate" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="一次性伤残补助金" prop="OneTimeDisabilityBenefit">
            <el-input v-model="formData.OneTimeDisabilityBenefit" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="保司告知杰博时间" prop="InsuranceCompReimbursesTime1">
            <el-date-picker type="date" placeholder="" v-model="formData.InsuranceCompReimbursesTime1" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账单位全称（保司-杰博）" prop="FullNameReceivingAccount1">
            <el-input v-model="formData.FullNameReceivingAccount1" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="到账时间" prop="AccountingDate1">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingDate1" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="其他" prop="Other">
            <el-input v-model="formData.Other" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="保司告知杰博时间" prop="InsuranceCompReimbursesTime2">
            <el-date-picker type="date" placeholder="" v-model="formData.InsuranceCompReimbursesTime2" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账单位全称（保司-杰博）" prop="FullNameReceivingAccount2">
            <el-input v-model="formData.FullNameReceivingAccount2" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="到账时间" prop="AccountingDate2">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingDate2" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="工伤工资" prop="InjuryPay">
            <el-input v-model="formData.InjuryPay" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="保司告知杰博时间" prop="InsuranceCompReimbursesTime3">
            <el-date-picker type="date" placeholder="" v-model="formData.InsuranceCompReimbursesTime3" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账单位全称（保司-杰博）" prop="FullNameReceivingAccount3">
            <el-input v-model="formData.FullNameReceivingAccount3" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="到账时间" prop="AccountingDate3">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingDate3" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="一次性工伤医疗补助金" prop="OneTimeWorkInjuryBenefit3">
            <el-input v-model="formData.OneTimeWorkInjuryBenefit3" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="保司告知杰博时间" prop="InsuranceCompReimbursesTime4">
            <el-date-picker type="date" placeholder="" v-model="formData.InsuranceCompReimbursesTime4" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账单位全称（保司-杰博）" prop="FullNameReceivingAccount4">
            <el-input v-model="formData.FullNameReceivingAccount4" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="到账时间" prop="AccountingDate4">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingDate4" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="离职时间" prop="DepartureTime">
            <el-date-picker type="date" placeholder="" v-model="formData.DepartureTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="一次性伤残就业补助金" prop="OneTimeWorkInjuryBenefit4">
            <el-input v-model="formData.OneTimeWorkInjuryBenefit4" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="保司告知杰博时间" prop="InsuranceCompReimbursesTime5">
            <el-date-picker type="date" placeholder="" v-model="formData.InsuranceCompReimbursesTime5" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账单位全称（保司-杰博）" prop="FullNameReceivingAccount5">
            <el-input v-model="formData.FullNameReceivingAccount5" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="到账时间" prop="AccountingDate5">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingDate5" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="三个一次性打包价" prop="ThreeTimePackages">
            <el-input v-model="formData.ThreeTimePackages" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="保司告知杰博时间" prop="InsuranceCompReimbursesTime6">
            <el-date-picker type="date" placeholder="" v-model="formData.InsuranceCompReimbursesTime6" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="到账单位全称（保司-杰博）" prop="FullNameReceivingAccount6">
            <el-input v-model="formData.FullNameReceivingAccount6" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="到账时间" prop="AccountingDate6">
            <el-date-picker type="date" placeholder="" v-model="formData.AccountingDate6" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="合计" prop="Total">
            <el-input v-model="formData.Total" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="Remark1">
            <template #label>
              <span>商保1赔付备注1
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>打折情况</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.Remark1" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="Remark2">
            <template #label>
              <span>商保1赔付备注2
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>理赔单情况</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.Remark2" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSubmit">提 交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    nextTick
  } from 'vue';
  export default {
    data() {
      return {
        listQuery: {
          InsuranceName: '', //险种名称
          ServerName: '', //服务商
          Bntype: '', //商保类别
          pageNum: 1,
          pageSize: 10,
        },
        tableData: [{
          name: '666'
        }],
        totalCount: 0,
        loading: false,
        showAdd: false,
        formData: {
          Id: '',
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          SecondReportingParty: '', //第二申报方（商保1）
          WorkInjuryMedicalExpense: '', //工伤医疗费
          InsuranceCompReimbursesTime: '', //保司告知杰博时间
          FullNameReceivingAccount: '', //到账单位全称（保司-杰博）
          AccountingDate: '', //到账时间
          OneTimeDisabilityBenefit: '', //一次性伤残补助金
          InsuranceCompReimbursesTime1: '', //保司告知杰博时间1
          FullNameReceivingAccount1: '', //到账单位全称（保司-杰博）1
          AccountingDate1: '', //到账时间1
          Other: '', //其他
          InsuranceCompReimbursesTime2: '', //保司告知杰博时间2
          FullNameReceivingAccount2: '', //到账单位全称（保司-杰博）2
          AccountingDate2: '', //到账时间2
          InjuryPay: '', //	工伤工资
          InsuranceCompReimbursesTime3: '', //保司告知杰博时间3
          FullNameReceivingAccount3: '', //到账单位全称（保司-杰博）3
          AccountingDate3: '', //到账时间3
          OneTimeWorkInjuryBenefit3: '', //一次性工伤医疗补助金3
          InsuranceCompReimbursesTime4: '', //保司告知杰博时间4
          FullNameReceivingAccount4: '', //到账单位全称（保司-杰博）4
          AccountingDate4: '', //到账时间4
          DepartureTime: '', //离职时间
          OneTimeWorkInjuryBenefit4: '', //一次性工伤医疗补助金4
          InsuranceCompReimbursesTime5: '', //保司告知杰博时间5
          FullNameReceivingAccount5: '', //到账单位全称（保司-杰博）5
          AccountingDate5: '', //到账时间5
          AccountingDate6:'',//到账时间6
          ThreeTimePackages: '', //三个一次性打包价
          InsuranceCompReimbursesTime6: '', //保司告知杰博时间6
          FullNameReceivingAccount6: '', //到账单位全称（保司-杰博）6
          Total: '', //合计
          Remark1: '', //备注1
          Remark2: '', //备注2
        },
        rules: {
          Idcard: {
            required: true,
            message: '请输入身份证号码',
            trigger: 'blur'
          },
          TimeInjury: {
            required: true,
            message: '请输入发生工伤时间（年-月-日）',
            trigger: 'blur'
          },
          SecondReportingParty: {
            required: true,
            message: '请输入第二申报方（商保1）',
            trigger: 'blur'
          },
          WorkInjuryMedicalExpense: {
            required: true,
            message: '请输入工伤医疗费',
            trigger: 'blur'
          },
          InsuranceCompReimbursesTime: {
            required: true,
            message: '请输入保司告知杰博时间',
            trigger: 'blur'
          },
          FullNameReceivingAccount: {
            required: true,
            message: '请输入到账单位全称（保司-杰博）',
            trigger: 'blur'
          },
          AccountingDate: {
            required: true,
            message: '请输入到账时间',
            trigger: 'blur'
          },
          OneTimeDisabilityBenefit: {
            required: true,
            message: '请输入一次性伤残补助金',
            trigger: 'blur'
          },
          InsuranceCompReimbursesTime1: {
            required: true,
            message: '请输入保司告知杰博时间',
            trigger: 'blur'
          },
          FullNameReceivingAccount1: {
            required: true,
            message: '请输入到账单位全称（保司-杰博）',
            trigger: 'blur'
          },
          AccountingDate1: {
            required: true,
            message: '请输入到账时间',
            trigger: 'blur'
          },
          Other: {
            required: true,
            message: '请输入其他',
            trigger: 'blur'
          },
          InsuranceCompReimbursesTime2: {
            required: true,
            message: '请输入保司告知杰博时间',
            trigger: 'blur'
          },
          FullNameReceivingAccount2: {
            required: true,
            message: '请输入到账单位全称（保司-杰博）',
            trigger: 'blur'
          },
          AccountingDate2: {
            required: true,
            message: '请输入到账时间',
            trigger: 'blur'
          },
          InjuryPay: {
            required: true,
            message: '请输入工伤工资',
            trigger: 'blur'
          },
          InsuranceCompReimbursesTime3: {
            required: true,
            message: '请输入保司告知杰博时间',
            trigger: 'blur'
          },
          FullNameReceivingAccount3: {
            required: true,
            message: '请输入到账单位全称（保司-杰博）',
            trigger: 'blur'
          },
          AccountingDate3: {
            required: true,
            message: '请输入到账时间',
            trigger: 'blur'
          },
          OneTimeWorkInjuryBenefit3: {
            required: true,
            message: '请输入一次性工伤医疗补助金',
            trigger: 'blur'
          },
          InsuranceCompReimbursesTime4: {
            required: true,
            message: '请输入保司告知杰博时间',
            trigger: 'blur'
          },
          FullNameReceivingAccount4: {
            required: true,
            message: '请输入到账单位全称（保司-杰博）',
            trigger: 'blur'
          },
          AccountingDate4: {
            required: true,
            message: '请输入到账时间',
            trigger: 'blur'
          },
          DepartureTime: {
            required: true,
            message: '请输入离职时间',
            trigger: 'blur'
          },
          OneTimeWorkInjuryBenefit4: {
            required: true,
            message: '请输入一次性伤残就业补助金',
            trigger: 'blur'
          },
          InsuranceCompReimbursesTime5: {
            required: true,
            message: '请输入保司告知杰博时间',
            trigger: 'blur'
          },
          FullNameReceivingAccount5: {
            required: true,
            message: '请输入到账单位全称（保司-杰博）',
            trigger: 'blur'
          },
          AccountingDate5: {
            required: true,
            message: '请输入到账时间',
            trigger: 'blur'
          },
          AccountingDate6: {
            required: true,
            message: '请输入到账时间',
            trigger: 'blur'
          },
          ThreeTimePackages: {
            required: true,
            message: '请输入三个一次性打包价',
            trigger: 'blur'
          },
          InsuranceCompReimbursesTime6: {
            required: true,
            message: '请输入保司告知杰博时间',
            trigger: 'blur'
          },
          FullNameReceivingAccount6: {
            required: true,
            message: '请输入到账单位全称（保司-杰博）',
            trigger: 'blur'
          },
          Total: {
            required: true,
            message: '请输入合计',
            trigger: 'blur'
          },
          Remark1: {
            required: true,
            message: '请输入商保1赔付备注1',
            trigger: 'blur'
          },
          Remark2: {
            required: true,
            message: '商保1赔付备注2',
            trigger: 'blur'
          },
        },
        injuryDateList: [], //工伤日期列表
        name: '',
        proName: '',
        roletype:localStorage.loginRoletype,
      }
    },
    created() {
      this.getWiclaimDetails2Bi7List()
    },
    methods: {
      checkPermission,
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getWiclaimDetails2Bi7List();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getWiclaimDetails2Bi7List();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getWiclaimDetails2Bi7List();
      },
      //取【7】赔付明细2-商保1列表
      getWiclaimDetails2Bi7List() {
        this.loading = true;
        xz.getWiclaimDetails2Bi7List(this.listQuery, this.roletype).then(res => {
          if (res.status == "ok") {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.loading = false;
            this.tableData = [];
          }
        })
      },
      //新增
      addNew() {
        this.clearForm();
        this.showAdd = true;
      },
      edit(item) {
        //取【7】赔付明细2-商保1详情
        xz.getWiclaimDetails2Bi7(item.r.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.formData = res.data;
          } else {
            this.formData = item;
          }
          this.showAdd = true;
        })
      },
      //确认新增/修改
      confirmSubmit() {
        this.$refs["formData"].validate((valid) => {
          if (valid) {
            xz.updataWiclaimDetails2Bi7(this.formData, this.roletype).then(res => {
              if (res.status == "ok") {
                this.showAdd = false;
                this.getWiclaimDetails2Bi7List();
                this.$message.success('新增成功！')
              } else {
                this.showAdd = false;
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      //删除【7】赔付明细2-商保1详情
      del(item) {
        xz.delWiclaimDetails2Bi7(item.r.Id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.getWiclaimDetails2Bi7List();
            this.$message.success('作废成功！')
          } else {
            this.getWiclaimDetails2Bi7List();
            this.$message.error(res.msg)
          }
        })
      },
      clearForm() {
        this.name = '';
        this.proName = '';
        this.formData = {
          Id: '',
          Idcard: '', //身份证号码
          TimeInjury: '', //发生工伤时间（年-月-日）
          SecondReportingParty: '', //第二申报方（商保1）
          WorkInjuryMedicalExpense: '', //工伤医疗费
          InsuranceCompReimbursesTime: '', //保司告知杰博时间
          FullNameReceivingAccount: '', //到账单位全称（保司-杰博）
          AccountingDate: '', //到账时间
          OneTimeDisabilityBenefit: '', //一次性伤残补助金
          InsuranceCompReimbursesTime1: '', //保司告知杰博时间1
          FullNameReceivingAccount1: '', //到账单位全称（保司-杰博）1
          AccountingDate1: '', //到账时间1
          Other: '', //其他
          InsuranceCompReimbursesTime2: '', //保司告知杰博时间2
          FullNameReceivingAccount2: '', //到账单位全称（保司-杰博）2
          AccountingDate2: '', //到账时间2
          InjuryPay: '', //	工伤工资
          InsuranceCompReimbursesTime3: '', //保司告知杰博时间3
          FullNameReceivingAccount3: '', //到账单位全称（保司-杰博）3
          AccountingDate3: '', //到账时间3
          OneTimeWorkInjuryBenefit3: '', //一次性工伤医疗补助金3
          InsuranceCompReimbursesTime4: '', //保司告知杰博时间4
          FullNameReceivingAccount4: '', //到账单位全称（保司-杰博）4
          AccountingDate4: '', //到账时间4
          DepartureTime: '', //离职时间
          OneTimeWorkInjuryBenefit4: '', //一次性工伤医疗补助金4
          InsuranceCompReimbursesTime5: '', //保司告知杰博时间5
          FullNameReceivingAccount5: '', //到账单位全称（保司-杰博）5
          AccountingDate5: '', //到账时间5
          AccountingDate6: '', //到账时间6
          ThreeTimePackages: '', //三个一次性打包价
          InsuranceCompReimbursesTime6: '', //保司告知杰博时间6
          FullNameReceivingAccount6: '', //到账单位全称（保司-杰博）6
          Total: '', //合计
          Remark1: '', //备注1
          Remark2: '', //备注2
        }
      },
      getIdcardInfo() {
        if (this.formData.Idcard.length == 18) {
          let data = {
            pageNum: 1,
            pageSize: 1000,
            Idcard: this.formData.Idcard
          }
          xz.getWIAccidentReportList(data, this.roletype).then(res => {
            if (res.status == "ok") {
              if (res.data.data.length > 0) {
                this.injuryDateList = res.data.data;
              } else {
                this.injuryDateList = [];
                this.$message.error('请先添加工伤事故报告信息')
              }
            } else {
              this.injuryDateList = [];
              this.$message.error('获取身份证信息失败')
            }
          })
        }
      },
      changeTimeInjury(val) {
        this.formData.TimeInjury = val.TimeInjury;
        this.name = val.InjuredEmployeeName;
        this.proName = val.ProjectName;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }
</style>
<style>
  .page_injuryTables .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_injuryTables .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_injuryTables .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_injuryTables .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_injuryTables .formData .el-form-item {
    margin-bottom: 10px;
  }

  .page_injuryTables .formData .el-form-item__error {
    top: 34px;
  }

  .page_injuryTables .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .formData .el-icon-question:before {
    color: #F56C6C;
  }
</style>